module.exports = __webpack_public_path__ + "static/media/energy_card_multi_1.8cc0226f.svg";